<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Create Application</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Name</label>
              <input type="text" class="form-control" v-model="application.name" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Client</label>
              <multiselect
                :show-labels="false"
                :options="clients"
                :value="findOption(clients, application.client_id)"
                @input="application.client_id = $event ? $event.id : null"
                label="text"
                track-by="id"
                placeholder=""
              ></multiselect>
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Project</label>
              <multiselect
                :show-labels="false"
                :options="projects"
                :value="findOption(projects, application.project_id)"
                @input="application.project_id = $event ? $event.id : null"
                label="text"
                track-by="id"
                placeholder=""
              ></multiselect>
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Git URL</label>
              <input type="text" class="form-control" v-model="application.git_url" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">App URL</label>
              <input type="text" class="form-control" v-model="application.app_url" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">API URL</label>
              <input type="text" class="form-control" v-model="application.api_url" />
            </div>
          </div>

          <h3 class="mt-3">Clusters</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Production</label>
              <multiselect
                :show-labels="false"
                :options="productionClusters"
                :value="findOption(productionClusters, application.cluster_id)"
                @input="application.cluster_id = $event ? $event.id : null"
                label="text"
                track-by="id"
                placeholder="Stack"
              ></multiselect>
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">QA</label>
              <multiselect
                :show-labels="false"
                :options="qaClusters"
                :value="findOption(qaClusters, application.qa_cluster_id)"
                @input="application.qa_cluster_id = $event ? $event.id : null"
                label="text"
                track-by="id"
                placeholder="QA Stack"
              ></multiselect>
            </div>
          </div>

          <h3 class="mt-3">RDS Credentials</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Username</label>
              <input type="text" class="form-control" v-model="application.terraform_rds_username" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Password</label>
              <input type="text" class="form-control" v-model="application.terraform_rds_password" />
            </div>
          </div>

          <h3 class="mt-3">Extra Variables</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">JWT Secret</label>
              <input type="text" class="form-control" v-model="application.terraform_jwt_secret" />
            </div>
          </div>

          <h3 class="mt-3">Environment Files</h3>
          <div class="mb-3">
            <label class="control-label">QA Environment File</label>
            <textarea class="form-control env-file" v-model="application.qa_env_file"></textarea>
          </div>
          <div class="mb-3">
            <label class="control-label">Production Environment File</label>
            <textarea class="form-control env-file" v-model="application.production_env_file"></textarea>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="createApplication" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CModal } from '@chameleon/chameleon-vue'
import { notify } from 'utils'
import Application from './../../models/application.js'
import { find } from 'lodash'

export default {
  extends: CModal,

  props: {
    clients: {
      type: Array,
      default: () => []
    },
    projects: {
      type: Array,
      default: () => []
    },
    clusters: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      application: new Application()
    }
  },

  computed: {
    productionClusters () {
      return this.clusters.filter(cluster => cluster.production)
    },

    qaClusters () {
      return this.clusters.filter(cluster => !cluster.production)
    }
  },

  mounted () {
    this.addEventListener('open', () => {
      this.application = new Application()
    })
  },

  methods: {
    findOption (options, id) {
      return find(options, option => option.id == id) || null
    },

    createApplication () {
      return client({ path: '/applications', entity: this.application, method: 'POST' }).then(
        (response) => {
          this.$emit('created', response.entity)
          this.close()
        },
        (response) => {
          notify.error(response.status && response.status.code === 422
            ? 'Failed to validate the request. Please check your inputs and try again.'
            : 'Failed to create the application. Please try again.')
        }
      )
    }
  }
}
</script>

<style scoped>
.env-file {
  height: 200px;
}
</style>
